export default __webpack_public_path__ + "static/media/26.9f053184.png";